<template>
    <div>
        <div>Por secciones</div>
        <v-treeview :items="items"></v-treeview>
    </div>
</template>
<script>
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    name: 'CMatConsejeria',
    mounted(){
        this.fuLoad();
    },
    data: () => ({
        dMatMatriculas: [],
        items: [],
    }),
    computed: {
        ...mapState(['ssUser']),
    },
    methods: {
        async fuLoad(){
            try {
                const response = await this.$apollo.query({
                    query: gql`query load($IdPersonal: Int!){
                        matmatriculaByConsejero(IdPersonal:$IdPersonal){
                            IdMatricula
                            IdSeccion
                            matseccion{
                                IdSeccion
                                Seccion
                                matperiodo{
                                    IdPeriodo
                                    Anio
                                    Periodo
                                    Nivel
                                    priservicio{
                                        IdServicio
                                        Iniciales
                                    }
                                }
                            }
                        }
                    }`,
                    variables: {
                        IdPersonal: this.ssUser.IdPersonal,
                    }
                })
                console.log(response.data);
                // this.dMatMatriculas = response.data.matmatriculaByConsejero
                // var data = this.dMatMatriculas.map(x => {
                //     var item = {"periodoName": x.matseccion.matperiodo.Anio+'-'+x.matseccion.matperiodo.Periodo,
                //                 "periodoId": x.matseccion.matperiodo.IdPeriodo,
                //                 "servicioName": x.matseccion.matperiodo.priservicio.Iniciales,
                //                 "servicioId": x.matseccion.matperiodo.priservicio.IdServicio,
                //                 "seccionName": x.matseccion.IdSeccion,
                //                 "seccionId": x.matseccion.matperiodo.Nivel+'°'+x.matseccion.Seccion}
                //     return item;
                // })

                // var keys = ["periodo", "servicio", "seccion"],
                //     result = data
                //         .reduce((r, o) => {
                //             keys.reduce((t, k) => {
                //                 var temp = (t.children = t.children || []).find(p => p.id === o[k + 'Id']);
                //                 if (!temp) {
                //                     t.children.push(temp = { name: o[k + 'Name'], id: o[k + 'Id'] });
                //                 }
                //                 return temp;
                //             }, r);
                //             return r;
                //         }, {})
                //         .children;

                // console.log(result);

                // this.items = result;
                
                //const YearsDistinct = [...new.js Set(Years)];
                //console.log(YearsDistinct);
                //console.log(TREE);
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Problema de Conexión.', 'error');
            } finally {
            }
        },
    },
}
</script>